import { render, staticRenderFns } from "./c_menu_list.vue?vue&type=template&id=6b44e854&scoped=true&"
import script from "./c_menu_list.vue?vue&type=script&lang=js&"
export * from "./c_menu_list.vue?vue&type=script&lang=js&"
import style0 from "./c_menu_list.vue?vue&type=style&index=0&id=6b44e854&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44e854",
  null
  
)

export default component.exports